/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import { faPaypal, faStripe, IconDefinition } from "@fortawesome/free-brands-svg-icons";
import {
    faAddressCard,
    faAngleDown,
    faAngleRight,
    faAnglesDown,
    faAnglesUp,
    faAngleUp,
    faArrowDownZA,
    faArrowLeft,
    faArrowPointer,
    faArrowRight,
    faArrowRightArrowLeft,
    faArrowRightToBracket,
    faArrowsRotate,
    faArrowToTop,
    faArrowUpAZ,
    faArrowUpRightFromSquare,
    faBackward,
    faBackwardFast,
    faBagShopping,
    faBallotCheck,
    faBan,
    faBarcodeRead,
    faBars,
    faBed,
    faBedEmpty,
    faBell,
    faBook,
    faBookCircleArrowRight,
    faBooks,
    faBoxArchive,
    faBoxCircleCheck,
    faBrainCircuit,
    faBrowser,
    faBuilding,
    faBuildingUser,
    faCalculator,
    faCalendarAlt,
    faCalendarLinesPen,
    faCaretDown,
    faCaretUp,
    faCashRegister,
    faChartBullet,
    faChartGantt,
    faChartLineUp,
    faChartSimple,
    faChartUser,
    faCheck,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faChevronUp,
    faCircle,
    faCircleCheck,
    faCircleExclamation,
    faCircleInfo,
    faCircleQuestion,
    faCirclesOverlap,
    faCircleUser,
    faClipboardCheck,
    faClipboardList,
    faClipboardQuestion,
    faClock,
    faCloudArrowUp,
    faCog,
    faCoins,
    faCommentEdit,
    faCommentLines,
    faCopy,
    faCreditCard,
    faDesktop,
    faDiagramVenn,
    faDownload,
    faEarthAmericas,
    faEdit,
    faEllipsisH,
    faEllipsisVertical,
    faEnvelope,
    faEnvelopeCircleCheck,
    faEnvelopeOpenText,
    faExclamation,
    faExternalLink,
    faEye,
    faFile,
    faFileArrowDown,
    faFileArrowUp,
    faFileCertificate,
    faFileCheck,
    faFileEdit,
    faFileImport,
    faFileInvoice,
    faFileInvoiceDollar,
    faFileMagnifyingGlass,
    faFilePdf,
    faFileSlash,
    faFileSpreadsheet,
    faFileWord,
    faFileXml,
    faFilter,
    faFlask,
    faFloppyDisk,
    faForkKnife,
    faForward,
    faForwardFast,
    faGear,
    faGlobe,
    faGripDotsVertical,
    faHandHoldingDollar,
    faHandHoldingHand,
    faHandshake,
    faHistory,
    faHotel,
    faHouseBuilding,
    faHouseLaptop,
    faIcons,
    faImage,
    faImages,
    faImageSlash,
    faInboxOut,
    faIndustry,
    faInfo,
    faKey,
    faLifeRing,
    faLink,
    faLinkSlash,
    faList,
    faListCheck,
    faListOl,
    faLocationDot,
    faMagnifyingGlass,
    faMailBulk,
    faMap,
    faMessageXmark,
    faMinus,
    faMoneyBill,
    faMoneyBillAlt,
    faMoneyBillTransfer,
    faMoneyCheckEditAlt,
    faMoneyFromBracket,
    faNewspaper,
    faOctagonExclamation,
    faPaperclip,
    faPaperPlane,
    faPaperPlaneTop,
    faPen,
    faPencil,
    faPencilPaintbrush,
    faPenNib,
    faPenNibSlash,
    faPenSquare,
    faPeopleArrows,
    faPeopleGroup,
    faPeopleRoof,
    faPercentage,
    faPerson,
    faPersonChalkboard,
    faPersonCircleExclamation,
    faPersonCirclePlus,
    faPersonCircleQuestion,
    faPersonShelter,
    faPhone,
    faPlus,
    faPresentationScreen,
    faPrint,
    faPrintMagnifyingGlass,
    faPuzzlePiece,
    faQuestion,
    faRecycle,
    faRightToBracket,
    faShare,
    faShieldQuartered,
    faShoePrints,
    faShoppingCart,
    faSignIn,
    faSlash,
    faSlashBack,
    faSlashForward,
    faSliders,
    faSortDown,
    faSortUp,
    faSpinner,
    faStar,
    faSymbols,
    faTable,
    faTags,
    faTasksAlt,
    faTelescope,
    faTextSize,
    faThumbsDown,
    faThumbsUp,
    faThumbtack,
    faThumbtackSlash,
    faTicket,
    faTimeline,
    faTimesCircle,
    faTrafficLight,
    faTrash,
    faTriangleExclamation,
    faUndo,
    faUser,
    faUserCheck,
    faUserClock,
    faUserEdit,
    faUserGear,
    faUserGroup,
    faUserLock,
    faUserMinus,
    faUserPlus,
    faUsers,
    faUsersBetweenLines,
    faUsersClass,
    faUsersGear,
    faUserTag,
    faUserTimes,
    faUtensils,
    faXmark,
} from "@fortawesome/pro-light-svg-icons";
import FontAwesomeSvgIcon, { FontAwesomeSvgIconProps } from "./FontAwesomeSvgIcon";
import './FontAwesome.scss';

export type FontAwesomeIconProps = Omit<FontAwesomeSvgIconProps, "icon">;

function createFontAwesomeIcon(icon: IconDefinition): React.FC<FontAwesomeIconProps> {
    return (props: FontAwesomeIconProps) => <FontAwesomeSvgIcon {...props} icon={icon} />;
}

export const AddressCardIcon = createFontAwesomeIcon(faAddressCard);
export const BellIcon = createFontAwesomeIcon(faBell);
export const CalculatorIcon = createFontAwesomeIcon(faCalculator);
export const CheckIcon = createFontAwesomeIcon(faCheck);
export const CogIcon = createFontAwesomeIcon(faCog);
export const EllipsisHIcon = createFontAwesomeIcon(faEllipsisH);
export const SpinnerIcon = createFontAwesomeIcon(faSpinner);
export const IndustryIcon = createFontAwesomeIcon(faIndustry);
export const UserIcon = createFontAwesomeIcon(faUser);
export const ListOlIcon = createFontAwesomeIcon(faListOl);
export const PrintIcon = createFontAwesomeIcon(faPrint);
export const Print2Icon = createFontAwesomeIcon(faPrintMagnifyingGlass);
export const PenSquareIcon = createFontAwesomeIcon(faPenSquare);
export const EMailIcon = createFontAwesomeIcon(faEnvelope);
export const TextDokumentIcon = createFontAwesomeIcon(faFileWord);
export const FileEditIcon = createFontAwesomeIcon(faFileEdit);
export const AttachmentIcon = createFontAwesomeIcon(faPaperclip);
export const FileIcon = createFontAwesomeIcon(faFile);
export const EditIcon = createFontAwesomeIcon(faEdit);
export const MinusIcon = createFontAwesomeIcon(faMinus);
export const PlusIcon = createFontAwesomeIcon(faPlus);
export const MailBulkIcon = createFontAwesomeIcon(faMailBulk);
export const TrafficLightIcon = createFontAwesomeIcon(faTrafficLight)
export const ArrowToTopIcon = createFontAwesomeIcon(faArrowToTop)
export const HistoryIcon = createFontAwesomeIcon(faHistory);
export const MoneyIcon = createFontAwesomeIcon(faMoneyBillAlt);
export const AbortIcon = createFontAwesomeIcon(faTimesCircle);
export const PdfIcon = createFontAwesomeIcon(faFilePdf);
export const UserCheckIcon = createFontAwesomeIcon(faUserCheck);
export const UserClockIcon = createFontAwesomeIcon(faUserClock);
export const UserRejectItem = createFontAwesomeIcon(faUserTimes);
export const FileCheckIcon = createFontAwesomeIcon(faFileCheck);
export const UserTagIcon = createFontAwesomeIcon(faUserTag);
export const CalendarAltIcon = createFontAwesomeIcon(faCalendarAlt);
export const KeyIcon = createFontAwesomeIcon(faKey);
export const UserEditIcon = createFontAwesomeIcon(faUserEdit);
export const BuildingIcon = createFontAwesomeIcon(faBuilding);
export const ListCheckIcon = createFontAwesomeIcon(faListCheck);
export const PercentageIcon = createFontAwesomeIcon(faPercentage);
export const HandshakeIcon = createFontAwesomeIcon(faHandshake);
export const QuestionIcon = createFontAwesomeIcon(faQuestion);
export const NewsIcon = createFontAwesomeIcon(faNewspaper);
export const StepsIcon = createFontAwesomeIcon(faShoePrints);
export const SupportIcon = createFontAwesomeIcon(faLifeRing);
export const InfoIcon = createFontAwesomeIcon(faInfo);
export const TaskIcon = createFontAwesomeIcon(faTasksAlt);
export const FilterIcon = createFontAwesomeIcon(faFilter);
export const FlaskIcon = createFontAwesomeIcon(faFlask);
export const PaperPlaneIcon = createFontAwesomeIcon(faPaperPlane);
export const PaperPlaneTopIcon = createFontAwesomeIcon(faPaperPlaneTop);
export const CommentEditIcon = createFontAwesomeIcon(faCommentEdit);
export const SignInIcon = createFontAwesomeIcon(faSignIn);
export const TelescopeIcon = createFontAwesomeIcon(faTelescope);
export const UsersIcon = createFontAwesomeIcon(faUsers);
export const UserLockIcon = createFontAwesomeIcon(faUserLock);
export const ShareIcon = createFontAwesomeIcon(faShare);
export const ShoppingCartIcon = createFontAwesomeIcon(faShoppingCart);
export const DownloadIcon = createFontAwesomeIcon(faDownload);
export const FileInvoiceIcon = createFontAwesomeIcon(faFileInvoice);
export const FileInvoiceDollarIcon = createFontAwesomeIcon(faFileInvoiceDollar);
export const ExternalLinkIcon = createFontAwesomeIcon(faExternalLink);
export const CoinsIcon = createFontAwesomeIcon(faCoins);
export const UsersClassIcon = createFontAwesomeIcon(faUsersClass);
export const PenPaintbrushIcon = createFontAwesomeIcon(faPencilPaintbrush);
export const BrowserIcon = createFontAwesomeIcon(faBrowser);
export const AngleRightIcon = createFontAwesomeIcon(faAngleRight);
export const ArrowLeftIcon = createFontAwesomeIcon(faArrowLeft);
export const BarsIcon = createFontAwesomeIcon(faBars);
export const ChartSimpleIcon = createFontAwesomeIcon(faChartSimple);
export const CircleUserIcon = createFontAwesomeIcon(faCircleUser);
export const GearIcon = createFontAwesomeIcon(faGear);
export const MoneyBillIcon = createFontAwesomeIcon(faMoneyBill);
export const PhoneIcon = createFontAwesomeIcon(faPhone);
export const SymbolsIcon = createFontAwesomeIcon(faSymbols);
export const SymbolsAltIcon = createFontAwesomeIcon(faIcons);
export const UserGroupIcon = createFontAwesomeIcon(faUserGroup);
export const AngleDownIcon = createFontAwesomeIcon(faAngleDown);
export const CircleCheckIcon = createFontAwesomeIcon(faCircleCheck);
export const CircleExclamationIcon = createFontAwesomeIcon(faCircleExclamation);
export const CircleInfoIcon = createFontAwesomeIcon(faCircleInfo);
export const TriangleExclamationIcon = createFontAwesomeIcon(faTriangleExclamation);
export const XIcon = createFontAwesomeIcon(faXmark);
export const EllipsisVerticalIcon = createFontAwesomeIcon(faEllipsisVertical);
export const MagnifyingGlassIcon = createFontAwesomeIcon(faMagnifyingGlass);
export const FileMagnifyingGlassIcon = createFontAwesomeIcon(faFileMagnifyingGlass);
export const CaretDownIcon = createFontAwesomeIcon(faCaretDown);
export const CaretUpIcon = createFontAwesomeIcon(faCaretUp);
export const CopyIcon = createFontAwesomeIcon(faCopy);
export const AngleUpIcon = createFontAwesomeIcon(faAngleUp);
export const CircleQuestionIcon = createFontAwesomeIcon(faCircleQuestion);
export const FloppyDiskIcon = createFontAwesomeIcon(faFloppyDisk);
export const TrashIcon = createFontAwesomeIcon(faTrash);
export const PersonIcon = createFontAwesomeIcon(faPerson);
export const ClipboardListIcon = createFontAwesomeIcon(faClipboardList);
export const ShieldQuarteredIcon = createFontAwesomeIcon(faShieldQuartered);
export const TextSizeIcon = createFontAwesomeIcon(faTextSize);
export const SlidersIcon = createFontAwesomeIcon(faSliders);
export const ListIcon = createFontAwesomeIcon(faList);
export const CircleIcon = createFontAwesomeIcon(faCircle);
export const EyeIcon = createFontAwesomeIcon(faEye);
export const GripDotsVerticalIcon = createFontAwesomeIcon(faGripDotsVertical);
export const PenIcon = createFontAwesomeIcon(faPen);
export const PersonChalkboardIcon = createFontAwesomeIcon(faPersonChalkboard);
export const PuzzlePieceIcon = createFontAwesomeIcon(faPuzzlePiece);
export const ArrowUpRightFromSquareIcon = createFontAwesomeIcon(faArrowUpRightFromSquare);
export const ArrowRightIcon = createFontAwesomeIcon(faArrowRight);
export const ArrowRightToBracketIcon = createFontAwesomeIcon(faArrowRightToBracket);
export const ArrowPointerIcon = createFontAwesomeIcon(faArrowPointer);
export const TimelineIcon = createFontAwesomeIcon(faTimeline);
export const CreditCardIcon = createFontAwesomeIcon(faCreditCard);
export const BanIcon = createFontAwesomeIcon(faBan);
export const UndoIcon = createFontAwesomeIcon(faUndo);
export const UserPlusIcon = createFontAwesomeIcon(faUserPlus);
export const UserMinusIcon = createFontAwesomeIcon(faUserMinus);
export const MoneyCheckEditAltIcon = createFontAwesomeIcon(faMoneyCheckEditAlt);
export const GlobeIcon = createFontAwesomeIcon(faGlobe);
export const PeopleRoofIcon = createFontAwesomeIcon(faPeopleRoof);
export const PencilIcon = createFontAwesomeIcon(faPencil);
export const PeopleGroupIcon = createFontAwesomeIcon(faPeopleGroup);
export const FileArrowUpIcon = createFontAwesomeIcon(faFileArrowUp);
export const FileArrowDownIcon = createFontAwesomeIcon(faFileArrowDown);
export const LinkIcon = createFontAwesomeIcon(faLink);
export const LinkSlashIcon = createFontAwesomeIcon(faLinkSlash);
export const BackwardIcon = createFontAwesomeIcon(faBackward);
export const BackwardFastIcon = createFontAwesomeIcon(faBackwardFast);
export const ForwardIcon = createFontAwesomeIcon(faForward);
export const ForwardFastIcon = createFontAwesomeIcon(faForwardFast);
export const ChartGanttIcon = createFontAwesomeIcon(faChartGantt);
export const AnglesDownIcon = createFontAwesomeIcon(faAnglesDown);
export const AnglesUpIcon = createFontAwesomeIcon(faAnglesUp);
export const ChevronUpIcon = createFontAwesomeIcon(faChevronUp);
export const ChevronDownIcon = createFontAwesomeIcon(faChevronDown);
export const ChevronRightIcon = createFontAwesomeIcon(faChevronRight);
export const ClockIcon = createFontAwesomeIcon(faClock);
export const CloudArrowUpIcon = createFontAwesomeIcon(faCloudArrowUp);
export const ClipboardQuestionIcon = createFontAwesomeIcon(faClipboardQuestion);
export const ChartBulletIcon = createFontAwesomeIcon(faChartBullet);
export const PersonCircleQuestionIcon = createFontAwesomeIcon(faPersonCircleQuestion);
export const BallotCheckIcon = createFontAwesomeIcon(faBallotCheck);
export const PayPalIcon = createFontAwesomeIcon(faPaypal);
export const ClipboardCheckIcon = createFontAwesomeIcon(faClipboardCheck);
export const FileSlashIcon = createFontAwesomeIcon(faFileSlash);
export const SlashIcon = createFontAwesomeIcon(faSlash);
export const SlashForwardIcon = createFontAwesomeIcon(faSlashForward);
export const SlashBackIcon = createFontAwesomeIcon(faSlashBack);
export const ChartLineUpIcon = createFontAwesomeIcon(faChartLineUp);
export const StarIcon = createFontAwesomeIcon(faStar);
export const MoneyBillTransferIcon = createFontAwesomeIcon(faMoneyBillTransfer);
export const StripeIcon = createFontAwesomeIcon(faStripe);
export const ArrowsRotateIcon = createFontAwesomeIcon(faArrowsRotate);
export const RightToBracketIcon = createFontAwesomeIcon(faRightToBracket);
export const CommentLinesIcon = createFontAwesomeIcon(faCommentLines);
export const TagsIcon = createFontAwesomeIcon(faTags);
export const SortDownIcon = createFontAwesomeIcon(faSortDown);
export const SortUpIcon = createFontAwesomeIcon(faSortUp);
export const ArrowRightArrowLeftIcon = createFontAwesomeIcon(faArrowRightArrowLeft);
export const MoneyFromBracketIcon = createFontAwesomeIcon(faMoneyFromBracket);
export const BooksIcon = createFontAwesomeIcon(faBooks);
export const HandHoldingDollarIcon = createFontAwesomeIcon(faHandHoldingDollar);
export const CashRegisterIcon = createFontAwesomeIcon(faCashRegister);
export const ImagesIcon = createFontAwesomeIcon(faImages);
export const ImageIcon = createFontAwesomeIcon(faImage);
export const ImageSlashIcon = createFontAwesomeIcon(faImageSlash);
export const PeopleArrowsIcon = createFontAwesomeIcon(faPeopleArrows);
export const BoxCircleCheckIcon = createFontAwesomeIcon(faBoxCircleCheck);
export const EnvelopeCircleCheckIcon = createFontAwesomeIcon(faEnvelopeCircleCheck);
export const UsersBetweenLinesIcon = createFontAwesomeIcon(faUsersBetweenLines);
export const EarthIcon = createFontAwesomeIcon(faEarthAmericas);
export const BoxArchiveIcon = createFontAwesomeIcon(faBoxArchive);
export const PersonCircleExclamationIcon = createFontAwesomeIcon(faPersonCircleExclamation);
export const ExclamationIcon = createFontAwesomeIcon(faExclamation);
export const ShoppingBagIcon = createFontAwesomeIcon(faBagShopping);
export const PresentationScreenIcon = createFontAwesomeIcon(faPresentationScreen);
export const BookIcon = createFontAwesomeIcon(faBook);
export const CalendarLinesPenIcon = createFontAwesomeIcon(faCalendarLinesPen);
export const DesktopIcon = createFontAwesomeIcon(faDesktop);
export const OctagonExclamationIcon = createFontAwesomeIcon(faOctagonExclamation);
export const FileCertificateIcon = createFontAwesomeIcon(faFileCertificate);
export const ArrowUpAZIcon = createFontAwesomeIcon(faArrowUpAZ);
export const ArrowDownZAIcon = createFontAwesomeIcon(faArrowDownZA);
export const UserGearIcon = createFontAwesomeIcon(faUserGear);
export const UsersGearIcon = createFontAwesomeIcon(faUsersGear);
export const BarcodeReadIcon = createFontAwesomeIcon(faBarcodeRead);
export const ThumbsUpIcon = createFontAwesomeIcon(faThumbsUp);
export const ThumbsDownIcon = createFontAwesomeIcon(faThumbsDown);
export const TicketIcon = createFontAwesomeIcon(faTicket);
export const HouseBuildingIcon = createFontAwesomeIcon(faHouseBuilding);
export const FileSpreadSheetIcon = createFontAwesomeIcon(faFileSpreadsheet);
export const TableIcon = createFontAwesomeIcon(faTable);
export const InboxOutIcon = createFontAwesomeIcon(faInboxOut);
export const PersonShelterIcon = createFontAwesomeIcon(faPersonShelter);
export const FileXmlIcon = createFontAwesomeIcon(faFileXml);
export const BuildingUserIcon = createFontAwesomeIcon(faBuildingUser);
export const BookArrowRightIcon = createFontAwesomeIcon(faBookCircleArrowRight);
export const HouseLaptopIcon = createFontAwesomeIcon(faHouseLaptop);
export const UtensilsIcon = createFontAwesomeIcon(faUtensils);
export const ForkKnifeIcon = createFontAwesomeIcon(faForkKnife);
export const PersonCirclePlusIcon = createFontAwesomeIcon(faPersonCirclePlus);
export const BrainCircuitIcon = createFontAwesomeIcon(faBrainCircuit);
export const PenNibIcon = createFontAwesomeIcon(faPenNib);
export const PenNibSlashIcon = createFontAwesomeIcon(faPenNibSlash);
export const FileImportIcon = createFontAwesomeIcon(faFileImport);
export const HandHoldingHandIcon = createFontAwesomeIcon(faHandHoldingHand);
export const ChevronLeftIcon = createFontAwesomeIcon(faChevronLeft);
export const ChartUserIcon = createFontAwesomeIcon(faChartUser);
export const RecycleIcon = createFontAwesomeIcon(faRecycle);
export const HotelIcon = createFontAwesomeIcon(faHotel);
export const RoadmapIcon = createFontAwesomeIcon(faMap);
export const ThumbtackIcon = createFontAwesomeIcon(faThumbtack);
export const ThumbtackSlashIcon = createFontAwesomeIcon(faThumbtackSlash);
export const LocationDotIcon = createFontAwesomeIcon(faLocationDot);
export const BedIcon = createFontAwesomeIcon(faBed);
export const BedEmptyIcon = createFontAwesomeIcon(faBedEmpty);
export const EnvelopeOpenTextIcon = createFontAwesomeIcon(faEnvelopeOpenText);
export const MessageXMarkIcon = createFontAwesomeIcon(faMessageXmark);
export const CirclesOverlapIcon = createFontAwesomeIcon(faCirclesOverlap);
export const DiagramVennIcon = createFontAwesomeIcon(faDiagramVenn);